<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="630"
    >
      <h3 slot="header" class="modal-header">专票资质申请修改</h3>

      <Form :label-width="120" ref="formData" :rules="formRules" :model="formData" :inline="true" v-if="formData">
        <FormItem label="项目名称" prop="projectId">
          <Select class="formwidth" v-model="formData.projectId">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList"
                    :value="item.value" :key="'keyA'+index">{{item.text}}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="公司名称" prop="companyName">
          <Input class="formwidth" v-model="formData.companyName"/>
        </FormItem>
        <FormItem label="纳税人识别号" prop="taxIdfa">
          <Input class="formwidth" v-model="formData.taxIdfa"/>
        </FormItem>
        <FormItem label="开户行" prop="bank">
          <Input class="formwidth" v-model="formData.bank"/>
        </FormItem>
        <FormItem label="开户行号" prop="bankNum">
          <Input class="formwidth" v-model="formData.bankNum"/>
        </FormItem>
        <FormItem label="电话" prop="phone">
          <Input class="formwidth" v-model="formData.phone"/>
        </FormItem>
        <FormItem label="地址" prop="address">
          <Input class="formwidth" v-model="formData.address"/>
        </FormItem>
        <FormItem label="公司注册地" prop="placeComapyName">
          <Select class="formwidth" v-model="formData.placeComapyName">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in comanyAddrList"
                    :value="item.name" :key="'keyA'+index">{{item.name}}
            </Option>
          </Select>
        </FormItem>
        <div class=" ivu-form-item " style="margin-left: 7%">
          <span style="width:82px;" class="inline-b ivu-form-item-label">资质证明</span>
          <div style="display:flex;">
            <div class="upload-wrap">
              <img class="imgwidth" v-if="formData.companyCertificateUrl"  :src="formData.companyCertificateUrl" @click="showImg(formData.companyCertificateUrl)"/>
              <Upload
                      :action="baseUrl+'/file/uploadFile'"
                      :on-success="handleSuccess0"
                      :headers="{'Access-Token':token}"
                      :show-upload-list="false"
                      :format="['jpg','jpeg','png']"
                      :on-format-error="handleError"
              >
                <div v-if="!formData.companyCertificateUrl" class="upload" :class="{error: !validateLicense1}">
                  <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
                  <p>点击上传图片</p>
                </div>
                <a v-if="formData.companyCertificateUrl" href="javascript:;">修改</a>
              </Upload>
            </div>
          </div>
        </div>
      </Form>
      <img-show :n="imgN" :src="imgSrc"></img-show>
    </Modal>
  </div>
</template>
<script>
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";
  import {getInvoiceCompetency,updateInvoiceCompetency} from "../../../../api/invoice";
  import ImgShow from 'components/ImgShow/index'


  export default {
    // name: "Add"   ,
    components: {
      ImgShow

    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      projectList:{
        type:Array,
        default:()=>{return []}
      },
      comanyAddrList:{
        type:Array,
        default:()=>{return []}
      },
      fid:{
        type:String,
        default:''
      }
    },
    watch: {
      n() {
        this.formData=null
        this.getInvoiceCompetency()
        this.isShow = true
      }
    },
    data() {
      return {
        imgSrc:'',
        imgN:0,
        token: '',
        baseUrl: '',
        loading: true,
        isShow: false,
        formData:null,
        validateLicense1:true,
        formRules: {
          "address": [
            {required: true, message: '请输入地址', trigger: 'blur', type: 'string'}
          ],
          "bank": [
            {required: true, message: '请输入开户行', trigger: 'blur', type: 'string'}
          ],
          "bankNum": [
            {required: true, message: '请输入开户行号', trigger: 'blur', type: 'string'}
          ],
          "companyName": [
            {required: true, message: '请输入公司名称', trigger: 'blur', type: 'string'}
          ],
          "phone": [
            {required: true, message: '请输入电话', trigger: 'blur', validator:this.validateNumber}
          ],
          "projectId": [
            {required: true, message: '请选择项目', trigger: 'change', type: 'string'}
          ],
          "taxIdfa": [
            {required: true, message: '请输入纳税人识别号', trigger: 'blur', type: 'string',validator: this.validateTaxIdfa}
          ],
          "placeComapyName": [
            {required: true, message: '请输入公司注册地址', trigger: 'change', type: 'string'}
          ],
        }
      }
    },
    methods: {
      validateNumber(rule, value, callback) {
        let pattern =  /^\d+-?\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入电话'));
        }
        callback();
      },
      validateTaxIdfa(rule, value, callback) {
        let pattern = /^[a-zA-Z0-9]+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入15、18、20位纳税人识别号'));
        }
        let length = value.length
        if (length !== 15 && length !== 18 && length !== 20){
          callback(new Error('字符长度只能输入15、18、20位'));
        }
        callback();
      },
      showImg(src){
        this.imgSrc=src
        this.imgN++
      },
      updateInvoiceCompetency(){
        updateInvoiceCompetency(this.formData).then(res=>{
          this.$Message.success("专票资质申请修改成功")
          this.$emit('done')
          this.isShow=false
        }).catch(error=>{
          this.$Message.info("专票资质申请修改失败")
          this.isShow=false
        })

      },
      getInvoiceCompetency(){
        let params={
          fid:this.fid
        }
        getInvoiceCompetency(params).then(res=>{
          this.formData=res.data

        }).catch(error=>{})

      },
      deleteImg(params){
        this.formData[params]=''
        this.formData[params+'Name']=''
      },
      handleError() {
        this.$Message.error("请输入jpg,jpeg,png,格式的文件");
      },
      handleSuccess0(response) {
        this.formData.companyCertificateUrl = response.data.url
        this.validateLicense1 = true
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        this.$refs['formData'].validate(bool=>{
          if(bool){
            this.updateInvoiceCompetency()
          }
          else {
            this.changeLoading()
          }
        })
      },
      cancel() {
      }
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }
  }
</script>

<style scoped>
  .formwidth {
    width: 320px;
  }
  .imgwidth {
    width: 167px;
    height: 118px;
  }
  .upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;

  }
  .upload-wrap {
    display: inline-block;
    line-height: 1;
    padding: 10px 4px;
  }

</style>
